import { __403__dp } from './__403__dp'
import { __404__dp } from './__404__dp'
import { __500__dp } from './__500__dp'
import { __uknown_error__dp } from './__uknown_error__dp'
import { PageJson } from '@wix/thunderbolt-becky-types'

const getPagesJson = (errorPageId: string | undefined): PageJson | null => {
	switch (errorPageId) {
		case '__403__dp':
			return (__403__dp as any) as PageJson
		case '__404__dp':
			return (__404__dp as any) as PageJson
		case '__500__dp':
			return (__500__dp as any) as PageJson
		case '__uknown_error__dp':
			return (__uknown_error__dp as any) as PageJson
		default:
			return null
	}
}

export default getPagesJson
